import { styled } from '@mui/material/styles';

export const DownloadSurveyCardWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.shades.shade100}`};
  padding: 24px;
  width: 100%;
  border-radius: 8px;
`;

export const IconWrapper = styled('div')`
  margin-bottom: 16px;
`;